export * from './attachment_icon';
